import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/site";
import { Quote } from "lucide-react";

export function Testimonials() {
  return (
    <section className="relative py-24 lg:py-32" data-testid="testimonials">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-magenta">Words from brands</p>
          <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-none tracking-tight sm:text-5xl lg:text-6xl">
            Trusted by teams around the world.
          </h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 2) * 0.08}>
              <figure className="h-full rounded-2xl border border-white/8 bg-surface/50 p-8" data-testid={`testimonial-${i}`}>
                <Quote className="h-7 w-7 text-orange/70" />
                <blockquote className="mt-5 text-lg font-light leading-relaxed text-white/90">"{t.quote}"</blockquote>
                <figcaption className="mt-6 border-t border-white/8 pt-5">
                  <div className="font-display font-semibold text-white">{t.name}</div>
                  <div className="text-sm text-muted">{t.role}</div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
